import { useRouteError } from 'react-router-dom';

export default function AppErrorFallback() {
  const error = useRouteError();
  const msg = error instanceof Error ? error.message : String(error ?? 'Unknown error');
  // eslint-disable-next-line no-console
  console.error('[AppErrorFallback]', error);

  const reload = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('_r', String(Date.now()));
    window.location.replace(url.toString());
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-bg-base text-text-main">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-xl font-semibold">Etwas ist schiefgelaufen</h1>
        <p className="text-sm text-text-muted">
          Die Seite konnte nicht geladen werden. Erneut versuchen oder zur Startseite.
        </p>
        <details className="text-xs text-text-muted/70 text-left bg-bg-input border border-slate-800 rounded-lg p-2">
          <summary className="cursor-pointer">Details</summary>
          <pre className="mt-1 whitespace-pre-wrap break-words">{msg}</pre>
        </details>
        <div className="flex gap-2 justify-center">
          <button
            onClick={reload}
            className="px-4 py-2 bg-accent text-bg-base rounded-lg text-sm font-medium hover:opacity-90"
          >
            Erneut laden
          </button>
          <a
            href="/"
            className="px-4 py-2 border border-slate-700 text-text-main rounded-lg text-sm hover:bg-bg-elevated"
          >
            Zur Startseite
          </a>
        </div>
      </div>
    </div>
  );
}
